







import Vue from 'vue';
import {Component, Prop} from "vue-property-decorator";
import AsiContentContainer from "../common/AsiContentContainer.vue";
import User from "@/models/user/User";
import PlanningEntryList from "@/components/planningEntry/PlanningEntryList.vue";

@Component({
	components: {PlanningEntryList, AsiContentContainer}
})
export default class UserTabPlanningEntries extends Vue {

	@Prop({type: Object, required: true})
	public user!: User;

}
